import React, { useEffect } from "react";
import { PropTypes } from "prop-types";
import { Select } from "..";
import { makeGetEntities } from "../../../redux/selectors/selectors";
import { useDispatch, useSelector } from "react-redux";
import { fetchPositions } from "../../../redux/actions/adminCustomerActions";
import { useTranslation } from "react-i18next";
import { sortBy } from "lodash";

const selector = makeGetEntities();

const PositionsFilter = ({ fieldName }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchPositions());
  }, []);

  const { positions, isLoading } = useSelector(({ adminCustomerState }) => ({
    positions: selector(adminCustomerState, {
      type: "position"
    }),
    isLoading: adminCustomerState.isPositionsLoading
  }));

  const menuItems = positions
    ? sortBy(positions, position =>
        position.name.toLowerCase()
      ).map(position => ({ value: position.id, label: position.name }))
    : [];

  menuItems.unshift({ value: "", label: t("filterLabels.showAll") });

  return (
    <Select
      disableUnderline
      name={fieldName}
      menuItems={menuItems}
      label={t("filterLabels.position")}
      loading={isLoading}
    />
  );
};

export default PositionsFilter;

PositionsFilter.propTypes = {
  fieldName: PropTypes.string
};

PositionsFilter.defaultProps = {
  fieldName: "position"
};
